import React, { useEffect, useState } from "react";
import AttendeesForm from "../components/AttendeesForm";
import ApiService from "utills/ApiService";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useGetIdentity, useTranslation } from "@refinedev/core";
import { IUserData } from "interfaces";
import { Breadcrumbs } from "components/breadcrumbs";
import { FullScreenLoading } from "components/fullScreenLoading";
import useWindowWidth from "utills/InitWidthDevice";
import { get } from "lodash";
import { TemplateDataType } from "../../types";
import { CollapsibleSection } from "components/collapsibleSection";

const WPSAttendeesSportsEdit = () => {
  const params = useParams();
  const navigate = useNavigate();
  const windowWidth = useWindowWidth();
  const { data: user } = useGetIdentity<IUserData>();
  const { translate, getLocale } = useTranslation();
  const language = getLocale();

  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Record<string, TemplateDataType> | null>(
    null
  );
  const [participant, setParticipant] = useState<any>(null);

  const breadcrumbItems = [
    {
      label: translate("attendees"),
      href: "/attendees/sports",
    },
    {
      label: translate("sport-attendees-edit"),
      href: `/attendees/sports/${params?.id}/edit`,
    },
  ];

  const handleGetDetail = async (token: string, id: string) => {
    setLoading(true);

    try {
      const res = await ApiService.get(`participants/${id}`, token);
      //   console.log("Detail participants:", res);

      setData(res);
      setParticipant(res?.participant);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleNavigateOrderDetail = (orderCode: string) => {
    navigate(`/orders/${orderCode}`);
  };

  useEffect(() => {
    if (windowWidth && windowWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);

  useEffect(() => {
    if (user?.token && params?.id) {
      handleGetDetail(user?.token, params?.id);
    }
  }, [user, params]);

  return (
    <div className="w-full">
      {loading && <FullScreenLoading />}

      <Breadcrumbs
        type="wps"
        breadcrumbItems={breadcrumbItems}
        disableBorder={true}
      />

      <div className="w-full relative">
        {/* Main Content */}
        {!loading && data && (
          <div className="mb-[100px] p-4 flex flex-col gap-5">
            {/* General information */}
            <CollapsibleSection
              defaultOpen={true}
              label={translate("general-information")}
            >
              <div
                className={`w-full p-6 grid grid-cols-1 lg:grid-cols-2 gap-4`}
              >
                <div className="w-full flex">
                  <span className="w-[200px] max-w-[200px] text-[14px] font-[500]">
                    {translate("status")}
                  </span>

                  {participant?.status === 1 ? (
                    <span className="w-[118px] py-1 rounded-[12px] font-medium flex justify-center bg-[#DCFCE7] text-[#1D813F]">
                      {translate("active")}
                    </span>
                  ) : (
                    <span className="w-[118px] py-1 rounded-[12px] font-medium flex justify-center bg-[#FFCFDD] text-[#9D0520]">
                      {translate("inactive")}
                    </span>
                  )}
                </div>

                <div className="w-full flex">
                  <span className="w-[200px] max-w-[200px] text-[14px] font-[500]">
                    {translate("category")}
                  </span>
                  <span className="text-[14px] font-[400]">
                    {participant?.category_name_en}
                  </span>
                </div>

                <div className="w-full flex">
                  <span className="w-[200px] max-w-[200px] text-[14px] font-[500]">
                    {translate("event-name")}
                  </span>
                  <span className="text-[14px] font-[400]">
                    {get(participant, `event_name_${language}`, "")}
                  </span>
                </div>

                <div className="w-full flex">
                  <span className="w-[200px] max-w-[200px] text-[14px] font-[500]">
                    {translate("is-tranferred")}
                  </span>

                  {participant?.is_transferred === "1" ? (
                    <span className="text-[14px] font-[400]">
                      {translate("yes")}
                    </span>
                  ) : (
                    <span className="text-[14px] font-[400]">
                      {translate("not")}
                    </span>
                  )}
                </div>

                <div className="w-full flex">
                  <span className="w-[200px] max-w-[200px] text-[14px] font-[500]">
                    {translate("ticket-name")}
                  </span>
                  <span className="text-[14px] font-[400]">
                    {get(participant, `product_name_${language}`, "")}
                  </span>
                </div>

                <div className="w-full flex">
                  <span className="w-[200px] max-w-[200px] text-[14px] font-[500]">
                    {translate("is-change-distance")}
                  </span>

                  {participant?.is_change_distance ? (
                    <span className="text-[14px] font-[400]">
                      {translate("yes")}
                    </span>
                  ) : (
                    <span className="text-[14px] font-[400]">
                      {translate("not")}
                    </span>
                  )}
                </div>

                <div className="w-full flex">
                  <span className="w-[200px] max-w-[200px] text-[14px] font-[500]">
                    {translate("time-to-change-distance")}
                  </span>
                  <span className="text-[14px] font-[400]">
                    {participant?.time_to_change_distance}
                  </span>
                </div>

                <div className="w-full flex">
                  <span className="w-[200px] max-w-[200px] text-[14px] font-[500]">
                    {translate("order-code")}
                  </span>

                  {/* {participant?.order_code && (
                    <span
                      className="text-[#011BB6] text-[14px] font-[400] hover:cursor-pointer"
                      onClick={() => {
                        handleNavigateOrderDetail(participant?.order_code);
                      }}
                    >
                      {participant?.order_code}
                    </span>
                  )} */}

                  {participant?.order_code && (
                    <Link
                      to={`/orders/${participant?.order_code}`}
                      className="w-fit text-[14px] font-medium text-brand-500 hover:underline"
                    >
                      {participant?.order_code}
                    </Link>
                  )}
                </div>
              </div>
            </CollapsibleSection>

            {/* Edit form */}
            <AttendeesForm initData={data} />
          </div>
        )}
      </div>
    </div>
  );
};

export default WPSAttendeesSportsEdit;
